import { device, mq } from "lib/media-query";
import styled from "styled-components";

export const FooterListHeader = styled.div`
    font-size: 1.3rem;
    font-weight: bolder;

    ${mq.to(device.TABLET)`
    height: 46px;
  `}
`;
